/**
 * Check if the current environment is development.
 */
function isDevelopmentEnv(): boolean {
  return process.env.NODE_ENV === "development";
}

export { isDevelopmentEnv };
